import { guestKeys } from '@seaters/constants';
import { useRejectGuestWaitingList } from '@seaters/data-access';
import { Button } from '@seaters/ui';
import { useIsMutating } from '@tanstack/react-query';
import { notification, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

export function RejectSeatsButton({ disabled }: { disabled?: boolean }) {
  const { t } = useTranslation();
  const searchParams = new URLSearchParams(window.location.search);

  const waitingListId = searchParams.get('waitingListId') || '';
  const code = searchParams.get('code') || '';
  const isHost = searchParams.get('host') === 'true';

  const rejectMutations = !!useIsMutating({
    mutationKey: guestKeys.rejectMutation(),
  });

  const { mutate: rejectAsGuest } = useRejectGuestWaitingList(waitingListId, {
    code,
  });

  const handleRejectAsGuest = () => {
    rejectAsGuest(undefined, {
      onSuccess: () => {
        notification.success({
          message: t('guest_app_decline'),
        });
      },
    });
  };
  const handleRejectSeats = () => {
    if (isHost) {
      console.log('host');
    } else {
      handleRejectAsGuest();
    }
  };
  // Declining can't be undone by the guest, so it asks first (WCAG 3.3.4).
  return (
    <Popconfirm
      title={t('guest_app_decline_confirm_title')}
      onConfirm={handleRejectSeats}
      okText={t('guest_app_decline_confirm_ok')}
      cancelText={t('general_no')}
      cancelButtonProps={{ autoFocus: true }}
      disabled={disabled}
      okButtonProps={{ 'data-testid': 'declineConfirmButton' }}
    >
      <Button
        size="large"
        loading={rejectMutations}
        disabled={disabled}
        data-testid="declineSeatsButton"
      >
        {t('guest_app_cancel')}
      </Button>
    </Popconfirm>
  );
}
